import React from 'react'
import { injectIntl, defineMessages, FormattedHTMLMessage } from 'react-intl'
import AnchorLink from '../components/AnchorLink'
import './BannerSection.scss'

const messages = defineMessages({
  siteName: {
    id: 'banner.siteName',
    defaultMessage: 'Stadyum CRM',
  },
  description: {
    id: 'banner.description',
    defaultMessage: 'Chytrý systém,<br /> který <strong>plní</strong> stadiony',
  },
})

const BannerSection = ({ intl }) => (
  <section className="banner-section">
    <a name="stadyum" id="stadyum" />
    <div className="overlay" />
    <h1 className="message">
      <span className="site-name">{intl.formatMessage(messages.siteName)}</span>
      <FormattedHTMLMessage {...messages.description} />
    </h1>
    <AnchorLink to="/#jak-to-funguje" className="down">
      <img src="/images/down-arrow.svg" alt="scroll-down" />
    </AnchorLink>
  </section>
)

BannerSection.propTypes = {
  intl: React.PropTypes.object.isRequired,
}

export default injectIntl(BannerSection)



// WEBPACK FOOTER //
// ./src/browser/BannerSection/BannerSection.js